<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Sync Customers from HubSpot'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="'Close'"
>
  <ng-container *nzModalContent>
    <div>
      <nz-table #basicTable [nzData]="contactHubSpotList()">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Company</th>
            <th>Position</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (data of basicTable.data; track data) {
            <tr>
              <td>{{ data.contact.properties.firstname }}</td>
              <td>{{ data.contact.properties.lastname }}</td>
              <td>{{ data.contact.properties.company }}</td>
              <td>{{ data.contact.properties.jobtitle }}</td>
              <td>
                @if (data.isAdded) {
                  <nz-tag nzColor="success">
                    <span nz-icon nzType="check-circle"></span>
                    <span>added</span>
                  </nz-tag>
                } @else {
                  <button nz-button nzType="default" nzSize="small" (click)="onAddToWorkspaceClick(data)">
                    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
                    Add to Workspace
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
    </div>
  </ng-container>
</nz-modal>
